import { createRef } from "react";

// layout
import ToatLayout from "../layout/ToatLayout";

// page
import HomePage from "../pages/HomePage";
import TalesPage from "../pages/TalesPage";
import ItineraryPage from "../pages/ItineraryPage";
import MapPage from "../pages/MapPage";

import TaleForm from "../components/forms/TaleForm";

/**
 * Feature route configuration objects used by the application's router.
 *
 * Each entry describes a route pattern, the element to render, and optional
 * per-route metadata consumed by layouts, navigation UI, and scroll handlers.
 *
 * @typedef {Object} Route
 * @property {string} path
 *   The URL path pattern for the route (e.g. "/", "/about"). Use "*" for a
 *   fallback/not-found route.
 *
 * @property {import('react').ReactNode} element
 *   The React element rendered when the route matches.
 *
 * @property {boolean} [index]
 *   When true marks this route as an index (default) route for its parent.
 *
 * @property {Handle} [handle]
 *   Arbitrary per-route metadata used by the application's layout, navigation,
 *   and scroll management logic.
 *
 * @typedef {Object} Handle
 * @property {string} [name]
 *   Human-readable name for the route (used for titles, breadcrumbs, nav items).
 *
 * @property {import('react').RefObject<HTMLElement>} [nodeRef]
 *   A React ref to the route's root DOM node (commonly created via createRef()).
 *
 * @property {import('react').ComponentType|function} [layout]
 *   Optional layout component used to wrap this route's element.
 *
 * @property {"top"|"remember"} [scrollState]
 *   Per-route scroll behavior:
 *     - "top"    = always scroll to top when navigating to this route
 *     - "remember" (or omitted) = allow the browser/router to remember scroll pos
 *
 * @constant {Route[]} baseRoutes
 *   The exported array of route descriptors.
 */
export const routes = [
  {
    path: "/toat",
    element: <HomePage />,
    handle: {
      name: "Toat",
      nodeRef: createRef(),
      layout: ToatLayout,
      scrollState: "top",
    },
  },
  {
    path: "/tale/list",
    element: <TalesPage />,
    handle: {
      name: "List of Tales",
      nodeRef: createRef(),
      layout: ToatLayout,
      scrollState: "top",
    },
  },
  {
    path: "/tale/add/:taleTitle",
    element: <TaleForm />,
    handle: {
      name: "New Tale",
      nodeRef: createRef(),
      layout: ToatLayout,
      scrollState: "top",
    },
  },
  {
    path: "/itinerary/:taleId",
    element: <ItineraryPage />,
    handle: {
      name: "Itinerary of Tale",
      nodeRef: createRef(),
      layout: ToatLayout,
      scrollState: "top",
    },
  },
  {
    path: "/map/:taleId",
    element: <MapPage />,
    handle: {
      name: "Map of Tale",
      nodeRef: createRef(),
      layout: ToatLayout,
      scrollState: "top",
    },
  },
];
